import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LocationService } from "@core/services/location.service";
import { PopUpNotificationService } from "@core/services/popup-notification.service";
import * as LocationAction from "@core/store/actions/location.action";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, debounceTime, mergeMap } from "rxjs/operators";

@Injectable()
export class LocationEffects {
  constructor(private actions$: Actions, private locationService: LocationService, private popupService: PopUpNotificationService) {}

  getAutocompleteResponses$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LocationAction.getAutocompleteResponses),
      debounceTime(500),
      mergeMap(({ input, lat, lng, retailerId }) => {
        return this.locationService.getAutocompleteSuggestions(input, lat, lng, retailerId).pipe(
          mergeMap(suggestions => {
            return [
              LocationAction.setAutocompleteResponses({ suggestions: suggestions ?? [] }),
              LocationAction.uiLocation({
                ui: [
                  { name: "noResults", value: (suggestions ?? []).length === 0 },
                  { name: "loadingResults", value: false },
                ],
              }),
            ];
          }),
          catchError((httpError: HttpErrorResponse) => {
            console.error({ httpError });
            const { error } = httpError;
            this.popupService.error(error);
            return of(LocationAction.Empty());
          })
        );
      })
    )
  );
}
